<div  *ngIf="!featureNewEditionsUXDesign" class="table-container overflow-auto">
  <table data-automation-id="loc-edtn-table" class="location-edition-table table">
    <caption class="d-none">List of editions and their details</caption>
    <thead class="location-edition-table__header">
    <tr data-automation-id="editions-table-header">
      <th data-automation-id="editions-table-header-cell" *ngIf="isExpandable"></th>
      <th translate data-automation-id="editions-table-header-cell">publicationDateTitle</th>
      <th translate data-automation-id="editions-table-header-cell">editionTitle</th>
      <th translate data-automation-id="editions-table-header-cell">detailsTitle</th>
      <th translate data-automation-id="editions-table-header-cell">publisherTitle</th>
      <th translate data-automation-id="editions-table-header-cell">physicalDescriptionTitle</th>
      <th translate data-automation-id="editions-table-header-cell">availabilityTitle</th>
    </tr>
    </thead>

    <tbody>
      <ng-container *ngFor="let edition of editions">
        <app-location-and-edition-table-rapido-item
            [fgTitle]="fgTitle"
            [edition]="edition"
            [tabName]="tabName"
            [label]="label"
            [isbn]="isbn"
            [attr.data-automation-id]="'table-row'"
            class="edition-information-row expand-cell"
        >
        </app-location-and-edition-table-rapido-item>
      </ng-container>
    </tbody>
  </table>
</div>

<div *ngIf="featureNewEditionsUXDesign" class="list-container">
  <ng-container *ngFor="let edition of editions; let idx = index">
    <app-location-and-edition-table-rapido-item
      [fgTitle]="fgTitle"
      [edition]="edition"
      [tabName]="tabName"
      [label]="label"
      [isbn]="isbn"
      [attr.data-automation-id]="'table-row'"
      class="edition-information-row expand-cell"
    >
    </app-location-and-edition-table-rapido-item>
  </ng-container>
</div>
